/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View} from 'react-native';
import {frequenceOptions} from '../../../../../../data/constants/Assurance/assuranceRetraite';
import {dataOption} from '../../../../../../data/types/interface/input';
import {buttonsStyles} from '../../../../../components/Button/boutonStyle';
import Button from '../../../../../components/Button/PrimaryButton';
import {DateTimePickerWeb} from '../../../../../components/Inputs/DateTimePicker/index.web';
import Input from '../../../../../components/Inputs/Input';
import Select from '../../../../../components/Inputs/Select';

const aList: dataOption[] = frequenceOptions;
export default function FormCotisationWeb({
  callBack,
  submit,
  defaultValue,
  requiredFields,
  isSubmited,
}: any) {
  React.useEffect(() => {}, [defaultValue]);

  return (
    <View>
      <DateTimePickerWeb
        defaultValue={defaultValue.DateNaissance}
        label="Date de naissance"
        callBack={(data: any) => {
          callBack('DateNaissance', data);
        }}
        requiredField={requiredFields.DateNaissance}
        maxAge={60}
        required
      />
      <Input
        label={`Cotisation à verser (Ar)`}
        name="Cotisation"
        defaultValue={defaultValue.Cotisation}
        parentCallback={(data: any) => {
          callBack('Cotisation', data);
        }}
        required
        type="numeric"
        requiredField={requiredFields.Cotisation}
        isSubmited={isSubmited}
      />
      <Select
        data={aList}
        label="Mode de versement de la cotisation"
        value={defaultValue.ModeVersement}
        onChange={(name: string, data: any) => {
          callBack('ModeVersement', data);
        }}
        required={true}
      />

      <View style={buttonsStyles.displayCenter}>
        <View style={buttonsStyles.displayHorizontal}>
          <Button
            onPress={() => submit(false, 'Cotisation')}
            styleBtnTxt={buttonsStyles.btnAnnuler}
            styleBtnOuter={buttonsStyles.btnAnnulerOuter}
            title="Annuler"
            type="annuler"
          />
          <Button
            onPress={() => submit(true, 'Cotisation')}
            styleBtnTxt={buttonsStyles.btnValider}
            styleBtnOuter={buttonsStyles.btnValiderOuter}
            title="Valider"
            type="valider"
          />
        </View>
      </View>
    </View>
  );
}
